import { createContext, type PropsWithChildren, useContext } from 'react';

type ResourceInfoProviderProps = {
  name: string | null;
};

export type ResourceInfoContextProps = ResourceInfoProviderProps;

const ResourceInfoContext = createContext<ResourceInfoContextProps>({
  name: null,
});

export const useResourceInfoContext = () => useContext(ResourceInfoContext);

export const ResourceInfoProvider = ({ children, ...value }: PropsWithChildren<ResourceInfoProviderProps>) => {
  return <ResourceInfoContext.Provider value={value}>{children}</ResourceInfoContext.Provider>;
};
